<template>
  <div>
    <div class="search-input-row">
      <el-input
        v-model="searchText"
        placeholder="搜索帖子"
        clearable
        size="large"
        :prefix-icon="Search"
        class="search-input"
        @keyup.enter="handleSearch"
        @clear="handleClearSearch"
      />
    </div>

    <el-card shadow="never" class="search-card">
      <div
        v-loading="loading"
        class="search-list-shelf"
        :class="{
          'search-list-shelf--placeholder': loading && records.length === 0,
        }"
      >
        <div class="search-result">
          <SearchResultItem
            v-for="item in records"
            :key="item.postId"
            :item="item"
            @need-login="openLogin"
            @open-profile="openUserProfile"
            @select-topic="goHomeTopic"
            @comment-count-change="(n) => (item.commentCount = n)"
          />
        </div>

        <el-empty v-if="!loading && records.length === 0" description="未找到相关帖子" />

        <div v-if="!loading && total > 0" class="pagination">
          <el-pagination
            v-model:current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            layout="prev, pager, next"
            @current-change="handlePageChange"
          />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { Search } from "@element-plus/icons-vue";
import { searchPage } from "@/api/search";
import SearchResultItem from "@/components/post/SearchResultItem.vue";

export default {
  name: "SearchView",
  components: { SearchResultItem },
  inject: {
    layoutRef: {
      default: () => ({
        openLoginDialog: () => {},
      }),
    },
  },
  data() {
    return {
      Search,
      loading: false,
      searchText: "",
      pageNum: 1,
      pageSize: 10,
      total: 0,
      records: [],
    };
  },
  mounted() {
    this.searchText = this.$route.query.q || "";
    this.pageNum = Number(this.$route.query.pageNum || 1);
    this.pageSize = Number(this.$route.query.pageSize || 10);
    this.fetchResults();
  },
  watch: {
    "$route.query"(query) {
      this.searchText = query.q || "";
      this.pageNum = Number(query.pageNum || 1);
      this.pageSize = Number(query.pageSize || 10);
      this.fetchResults();
    },
  },
  methods: {
    async fetchResults() {
      const keyword = (this.searchText || "").trim();
      const kw = keyword || undefined;
      this.loading = true;
      try {
        const res = await searchPage(kw, this.pageNum, this.pageSize);
        const data = res?.data?.data || {};
        this.records = data.records || [];
        this.total = data.total || 0;
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      const keyword = (this.searchText || "").trim();
      this.$router.push({
        path: "/search",
        query: {
          ...(keyword ? { q: keyword } : {}),
          pageNum: 1,
          pageSize: this.pageSize,
        },
      });
    },
    handleClearSearch() {
      this.$router.replace({
        path: "/search",
        query: { pageNum: 1, pageSize: this.pageSize },
      });
    },
    handlePageChange(page) {
      this.pageNum = page;
      this.$router.push({
        path: "/search",
        query: {
          ...(this.searchText ? { q: this.searchText } : {}),
          pageNum: page,
          pageSize: this.pageSize,
        },
      });
    },
    openLogin() {
      this.layoutRef?.openLoginDialog?.("login");
    },
    openUserProfile(userId) {
      if (userId == null || userId === "") return;
      const route = this.$router.resolve({ path: `/profile/${userId}` });
      window.open(route.href, "_blank");
    },
    goHomeTopic(topicId) {
      this.$router.push({ path: "/", query: topicId != null ? { topicId } : {} });
    },
  },
};
</script>

<style scoped>
.search-input-row {
  text-align: center;
  margin-bottom: 16px;
}

.search-input {
  width: 50%;
}

.search-input :deep(.el-input__wrapper) {
  min-height: 48px;
  padding-top: 4px;
  padding-bottom: 4px;
}

.search-card {
  border: none;
}

.search-list-shelf {
  position: relative;
  min-height: 0;
}

.search-list-shelf--placeholder {
  min-height: 420px;
}

.search-result {
  display: flex;
  flex-direction: column;
}

.pagination {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
  .search-input {
    width: 100%;
  }
}
</style>
